import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { useState, useEffect, useRef } from 'react';
import Api from '../api/api';
import StringHelpers from '../../utilities/stringHelpers';
import { toDateString, toTimeString, toDateTimeString, toInputFieldDateTimeString } from '../../utilities/dateUtilities';
import Payments from './../breaches/_payments';
import stringHelpers from '../../utilities/stringHelpers';
import roleUtilities from '../../utilities/roleUtilities';
import { ErrorModal } from '../../utilities/errorModal';
import {SuccessModal} from '../shared/successModal'
var cloneDeep = require('lodash.clonedeep');
var hash = require('object-hash');

function WardenSite(props) {
    const WardenSiteViewStep = {
        EnterVrm: 0,
        AllowedVrm: 1,
        CheckPayments: 2,
        CreateTicket: 3,
        Review: 4
    }

    const [currentView, setCurrentView] = useState(WardenSiteViewStep.EnterVrm);

    const [vrm, setVrm] = useState("");
    const [siteId, setSiteId] = useState(props.match.params.siteId);
    const [site, setSite] = useState(null);
    const [allowList, setAllowList] = useState(null);
    const [allowedVrm, setAllowedVrm] = useState(null);

    const [model, setModel] = useState("");
    const [make, setMake] = useState("");
    const [colour, setColour] = useState("");
    const [notes, setNotes] = useState("");
    const [observedFrom, setObservedFrom] = useState(new Date());
    const [observedTo, setObservedTo] = useState(new Date());
    const [allContraventions, setAllContraventions] = useState(null);
    const [contraventions, setContraventions] = useState(null);
    const [contraventionId, setContraventionId] = useState(null);
    const [contraventionName, setContraventionName] = useState(null);
    const [attachments, setAttachments] = useState([]);
    const [isDraggingOver, setIsDraggingOver] = useState(false);
    const [dropUploads, setDropUploads] = useState([]);
    const [carouselOpen, setCarouselOpen] = useState(false);
    const [carouselIndex, setCarouselIndex] = useState(0);
    const fileInputRef = useRef(null);

    const onFileInputChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            Array.from(e.target.files).forEach(file => uploadDroppedFile(file));
            e.target.value = '';
        }
    };

    const uploadDroppedFile = (file) => {
        const uploadEntry = { file, progress: 1, isComplete: false, isError: false };
        setDropUploads(prev => [...prev, uploadEntry]);

        const payload = new FormData();
        payload.append('file', file);

        const xhr = new XMLHttpRequest();

        xhr.upload.onerror = () => {
            setDropUploads(prev => prev.map(upload => upload.file === file ? { ...upload, isError: true } : upload));
        };

        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    const result = JSON.parse(xhr.response);
                    setDropUploads(prev => prev.map(upload => upload.file === file ? { ...upload, isComplete: true } : upload));
                    addAttachment(result);
                } else {
                    setDropUploads(prev => prev.map(upload => upload.file === file ? { ...upload, isError: true } : upload));
                }
            }
        };

        xhr.upload.onprogress = (progressEvent) => {
            const percentage = Math.max(1, Math.floor((progressEvent.loaded / progressEvent.total) * 1000) / 10);
            setDropUploads(prev => prev.map(upload => upload.file === file ? { ...upload, progress: percentage } : upload));
        };

        xhr.open('POST', process.env.REACT_APP_APT_API_URL + '/' + props.organisationId + '/attachments/upload-and-resize-image', true);
        xhr.send(payload);
    };

    const onFormDragOver = function (e) {
        e.preventDefault();
        setIsDraggingOver(true);
    };

    const onFormDragLeave = function (e) {
        setIsDraggingOver(false);
    };

    const onFormDrop = function (e) {
        e.preventDefault();
        setIsDraggingOver(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            Array.from(e.dataTransfer.files).forEach(file => uploadDroppedFile(file));
        }
    };

    const [canSave, setCanSave] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null)
    const [successMessage, setSuccessMessage] = useState(null)

    const backToSiteSelectUrl = roleUtilities.isWarden(props.user, props.organisationId) ? "/" : "/warden"

    const changeVrm = function (str) {
        if (!StringHelpers.isNullOrEmpty(str)) {
            setVrm(StringHelpers.cleanVrm(str));
        } else {
            setVrm("");
        }
    }

    const changeObservedFrom = function (str) {
        if (!StringHelpers.isNullOrEmpty(str)) {
            setObservedFrom(new Date(str));
        } else {
            setObservedFrom(null);
        }
    }

    const changeObservedTo = function (str) {
        if (!StringHelpers.isNullOrEmpty(str)) {
            setObservedTo(new Date(str));
        } else {
            setObservedTo(null);
        }
    }

    const getAllContraventions = function () {
        Api.getContraventions(
            (data) => setAllContraventions(data),
            (error) => console.log(error),
            props.organisationId,
            props.token
        )
    };

    const addAttachment = function (attachment) {
        setAttachments(prev => prev.concat([attachment]));
    };
    
    const removeAttachment = function(attachmentId) {
        let attachmentsClone = cloneDeep(attachments);
        let filtered = attachmentsClone.filter(function (x) {
            return x.id !== attachmentId;
        });

        setAttachments(filtered);
    };
    
    const setLookupData = function (data) {
        setColour(data.vehicleColour);
        setMake(data.vehicleMake);
        setModel(data.vehicleModel);
    };

    const getSiteContraventions = function () {
        Api.getSiteContraventions(
            (data) => setContraventions(data),
            (error) => console.log(error),
            props.organisationId,
            siteId,
            props.token
        )
    };

    const getSite = function () {
        Api.getSite(
            (data) => setSite(data),
            (error) => console.log(error),
            siteId,
            props.organisationId,
            props.token,
        )
    };

    const enterVrmNext = function () {
        Api.searchAllowedVrms(
            (data) => {
                setAllowList(data);
                const currentDate = new Date();
                const allowListItem = data.items.find(
                    item => {
                        if (
                            (!item.startDate && !item.endDate) ||
                            (new Date(item.startDate) < currentDate && new Date(item.endDate) > currentDate)
                        ) return item
                    }
                )
                if (allowListItem && allowListItem !== undefined) {

                    setAllowedVrm(allowListItem);
                    setMake(allowListItem.vehicleMake);
                    setModel(allowListItem.vehicleModel);
                    setColour(allowListItem.vehicleColour);
                    
                    setCurrentView(WardenSiteViewStep.AllowedVrm);
                } else {
                    setCurrentView(WardenSiteViewStep.CheckPayments);
                }
            },
            (error) => console.log(error),
            1,
            0,
            "",
            vrm,
            null,
            null,
            1,
            siteId,
            0,
            null,
            0,
            null,
            null,
            null,
            false,
            null,
            props.organisationId,
            props.token,
            true
        );
    };

    const createTicket = function () {
        
        Api.addWardenBreach(
            (data) => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)   
                } else {
                    setSuccessMessage("Breach logged successfully")
                    reset();
                }
            },
            (error) => {console.log(error); setErrorMessage(error.errorMessage)},
            siteId, vrm, colour, make, model, contraventionId, attachments.map(x => x.id), observedFrom, observedTo, props.organisationId, props.token
        )
    };

    const reset = function () {
        setCurrentView(WardenSiteViewStep.EnterVrm);
        setVrm("");
        setAllowedVrm(null);
        setColour("");
        setMake("");
        setModel("");
        setNotes("");
        setObservedFrom(new Date());
        setObservedTo(new Date());
        setContraventionId(null);
        setContraventionName(null);
        setAttachments([]);
    };

    useEffect(() => {

        if (allContraventions && allContraventions !== null && allContraventions.length > 0) {
            let found = allContraventions.find(x => x.id === contraventionId);
            if (found && found !== null) {
                setContraventionName(found.name);
            }
            else {
                setContraventionName("");
            }
        }
    }, [contraventionId])

    useEffect(() => {
        setCanSave(!StringHelpers.anyAreNullOrEmpty([contraventionId, vrm, make, model, colour]));
    }, [contraventionId, vrm, make, model, colour]);

    useEffect(() => {
        if (siteId !== null && siteId !== undefined) {
            getSite();
            getSiteContraventions();
            getAllContraventions();
        }
    }, []);

    const carouselImages = attachments.filter(item => item.isImage);

    useEffect(() => {
        if (!carouselOpen) return;
        const handleKeyDown = (e) => {
            if (e.key === 'ArrowLeft') setCarouselIndex(i => (i - 1 + carouselImages.length) % carouselImages.length);
            if (e.key === 'ArrowRight') setCarouselIndex(i => (i + 1) % carouselImages.length);
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [carouselOpen, carouselIndex]);

    return (
        <div className="container-fluid">
            <div className="row flex-center min-vh-50 py-6">
                <div className="col-sm-12 col-xl-8 col-xxl-6">
                    <div className="card">
                        <div className="card-header bg-light">
                            <h5 className="mb-0">Create a ticket</h5>
                        </div>
                        <div className="card-body p-2 px-sm-2 pt-sm-5">
                            {currentView === WardenSiteViewStep.EnterVrm &&
                                <>
                                    <div className='container-fluid'>
                                        <div className="row mb-2">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">Vehicle Registration Mark (VRM)</label>
                                            <div className="col-sm-8">
                                                <input className="form-control form-control-sm" type="text" value={vrm} onChange={(e) => changeVrm(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-100 position-relative mt-sm-5">
                                        <hr className="text-300 mb-2" />
                                    </div>
                                    <div className="form-group mb-0">
                                        <div className="row no-gutters d-flex">
                                            <div className="col-12 d-flex justify-content-between">
                                                <div>
                                                    <Link className="btn btn-default btn-sm" to={backToSiteSelectUrl}> <i className="fas fa-arrow-left"></i> Back</Link>
                                                </div>
                                                <div className='d-flex justify-content-end'>
                                                    <button type="button" className="btn btn-default btn-sm ml-2" onClick={reset}>
                                                        <i className="fas fa-times"></i> Clear</button>
                                                    <button type="button" className="btn btn-success btn-sm ml-2" disabled={StringHelpers.isNullOrEmpty(vrm)} onClick={enterVrmNext}>
                                                        Next <i className="fas fa-arrow-right"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }

                            {currentView === WardenSiteViewStep.CheckPayments &&
                                <>
                                    <Payments vrm={vrm} breachDate={new Date()} siteId={site?.id} organisationId={props.organisationId} token={props.token} dateSearchMode={1} lookupDataInEdit={false} />

                                    <div className="w-100 position-relative mt-sm-5">
                                        <hr className="text-300 mb-2" />
                                    </div>
                                    <div className="form-group mb-0">
                                        <div className="row no-gutters d-flex">
                                            <div className="col-12 d-flex justify-content-between">
                                                <button className="btn btn-default btn-sm" onClick={reset}> <i className="fas fa-arrow-left"></i> Back</button>
                                                <button type="button" className="btn btn-success btn-sm ml-2" onClick={() => setCurrentView(WardenSiteViewStep.CreateTicket)}>Next <i className="fas fa-arrow-right"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
          
                            {(currentView === WardenSiteViewStep.CreateTicket || currentView == WardenSiteViewStep.Review) &&
                                <>
                                    <div className='container-fluid'>
                                        <div className="row mb-2 align-items-center">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">Contravention</label>
                                            <div className="col-sm-8">
                                                {currentView === WardenSiteViewStep.Review &&
                                                    <p class="form-control-plaintext form-control-sm outline-none" >{contraventionName}</p>
                                                }
                                                {currentView === WardenSiteViewStep.CreateTicket &&
                                                    <select className='custom-select custom-select-sm' onChange={(e) => setContraventionId(e.target.value)}>
                                                        <option></option>
                                                        {contraventions !== null && allContraventions !== null && contraventions.map((item) => {
                                                            var contra = null;
                                                            allContraventions.forEach(contravention => {
                                                                if (item.contraventionId === contravention.id && contravention.contraventionType === 1) {
                                                                    contra = contravention;
                                                                }
                                                            });
                                                            if (contra !== null) {
                                                                return (
                                                                    <option value={contra.id} selected={contra.id === contraventionId}>{contra.name}</option>
                                                                )
                                                            }
                                                        })}
                                                    </select>
                                                }

                                            </div>
                                        </div>
                                        <div className="row mb-2 align-items-center">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">VRM</label>
                                            <div className="col-sm-8">
                                                {currentView === WardenSiteViewStep.Review &&
                                                    <div className="warden-plate-container"><p className="small-number-plate mb-0">{vrm}</p></div>
                                                }
                                                {currentView === WardenSiteViewStep.CreateTicket &&
                                                    <div className="form-group mb-1 warden-plate">
                                                        <input className="form-control mb-1 small-number-plate" type="text" value={vrm.toUpperCase()} onChange={(e) => changeVrm(e.target.value)} />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">Vehicle Make</label>
                                            <div className="col-sm-8">
                                                {currentView === WardenSiteViewStep.Review &&
                                                    <p class="form-control-plaintext form-control-sm outline-none" >{make}</p>
                                                }
                                                {currentView === WardenSiteViewStep.CreateTicket &&
                                                    <input className="form-control form-control-sm" type="text" value={make} onChange={(e) => setMake(e.target.value)} />
                                                }
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">Vehicle Model</label>
                                            <div className="col-sm-8">
                                                {currentView === WardenSiteViewStep.Review &&
                                                    <p class="form-control-plaintext form-control-sm outline-none" >{model}</p>
                                                }
                                                {currentView === WardenSiteViewStep.CreateTicket &&
                                                    <input className="form-control form-control-sm" type="text" value={model} onChange={(e) => setModel(e.target.value)} />
                                                }
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">Color</label>
                                            <div className="col-sm-8">
                                                {currentView === WardenSiteViewStep.Review &&
                                                    <p class="form-control-plaintext form-control-sm outline-none" >{colour}</p>
                                                }
                                                {currentView === WardenSiteViewStep.CreateTicket &&
                                                    <input className="form-control form-control-sm" type="text" value={colour} onChange={(e) => setColour(e.target.value)} />
                                                }
                                            </div>
                                        </div>
                                        {currentView === WardenSiteViewStep.CreateTicket &&
                                            <div className="row mb-3">
                                                <div className="offset-md-4 col-auto">
                                                    <button className="btn btn-primary btn-sm" onClick={() => Api.vehicleLookup((data) => setLookupData(data), null, vrm, props.organisationId, props.token)}>Lookup Details <i className="fas fa-search"></i></button>
                                                </div>
                                            </div>
                                        }
                                        <div className="row mb-2">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">Observed from</label>
                                            <div className="col-sm-8">
                                                {currentView === WardenSiteViewStep.Review &&
                                                    <p class="form-control-plaintext form-control-sm outline-none" >{toDateTimeString(observedFrom)}</p>
                                                }
                                                {currentView === WardenSiteViewStep.CreateTicket &&
                                                    <input className="form-control form-control-sm" type="datetime-local" value={toInputFieldDateTimeString(observedFrom)} onChange={(e) => changeObservedFrom(e.target.value)} />
                                                }
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">Observed to</label>
                                            <div className="col-sm-8">
                                                {currentView === WardenSiteViewStep.Review &&
                                                    <p class="form-control-plaintext form-control-sm outline-none" >{toDateTimeString(observedTo)}</p>
                                                }
                                                {currentView === WardenSiteViewStep.CreateTicket &&
                                                    <input className="form-control form-control-sm" type="datetime-local" value={toInputFieldDateTimeString(observedTo)} onChange={(e) => changeObservedTo(e.target.value)} />
                                                }
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">Notes</label>
                                            <div className="col-sm-8">
                                                {currentView === WardenSiteViewStep.Review &&
                                                    <p class="form-control-plaintext form-control-sm outline-none" >{notes}</p>
                                                }
                                                {currentView === WardenSiteViewStep.CreateTicket &&
                                                    <textarea className="form-control form-control-sm" value={notes} onChange={(e) => setNotes(e.target.value)} />
                                                }
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">Site</label>
                                            <div className="col-sm-8">
                                                <p class="form-control-plaintext form-control-sm outline-none" >{site.name}</p>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">Type</label>
                                            <div className="col-sm-8">
                                                <p class="form-control-plaintext form-control-sm outline-none" >MNPR</p>
                                            </div>
                                        </div>
                                        {currentView === WardenSiteViewStep.CreateTicket &&
                                            <>
                                                <div className="row mb-2">
                                                    <label className="col-sm-4 col-form-label col-form-label-sm">Attachments</label>
                                                    <div className="col-sm-8">
                                                        <div
                                                            className="attachment-drop-zone"
                                                            onDragOver={onFormDragOver}
                                                            onDragEnter={onFormDragOver}
                                                            onDragLeave={onFormDragLeave}
                                                            onDrop={onFormDrop}
                                                            style={{
                                                                borderColor: isDraggingOver ? '#2c7be5' : '#d8e2ef',
                                                                backgroundColor: isDraggingOver ? '#e8f0fe' : 'transparent',
                                                            }}
                                                        >
                                                            <input type="file" ref={fileInputRef} onChange={onFileInputChange} multiple style={{ display: 'none' }} accept="image/*,application/pdf,.doc,.docx" />
                                            <button className="btn btn-falcon-default btn-sm" onClick={() => fileInputRef.current.click()}><i className="fas fa-plus"></i> Add Attachment</button>
                                                            <p className="attachment-drop-zone-hint mb-0 mt-1" style={{ color: isDraggingOver ? '#2c7be5' : '#9da9bb' }}>
                                                                {isDraggingOver ? 'Drop to upload' : 'or drag and drop files here'}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                            </>
                                        }
                                        {(attachments.length > 0 || dropUploads.filter(upload => !upload.isComplete).length > 0) &&
                                            <div className="row mb-2">
                                                <div className="offset-sm-4 col-sm-8">
                                                    <table className="table table-sm table-borderless mb-0 table-striped table-dashboard fs--1 data-table no-footer ">
                                                        <tbody>
                                                            {attachments.map((item) => <tr key={hash(item)}>
                                                                <td className="pl-0">
                                                                    {item.isImage &&
                                                                        <img src={item.url} className="attachment-thumb cursor-pointer" style={{ width: "75px", height: "75px", objectFit: "cover" }} onClick={ () => { setCarouselIndex(carouselImages.indexOf(item)); setCarouselOpen(true); } } />
                                                                    }
                                                                    {!item.isImage && <>
                                                                        {item.contentType === "application/pdf" && <div className="d-flex justify-content-center my-2"><i className="far fa-6x fa-file-pdf"></i></div>}
                                                                        {item.contentType === "application/word.doc" && <div className="d-flex justify-content-center my-2"><i className="far fa-file-word"></i></div>}
                                                                        {item.contentType !== "application/word.doc" && item.contentType !== "application/pdf" && <div className="d-flex justify-content-center my-2"><i className="far fa-file-alt"></i></div>}
                                                                    </>}
                                                                </td>
                                                                <td><span style={{wordBreak: "break-all"}}>{item.filename}</span></td>
                                                                <td className="text-right">
                                                                    {currentView === WardenSiteViewStep.CreateTicket &&
                                                                        <button type="button" className="btn btn-danger btn-sm ml-2" onClick={() => removeAttachment(item.id)}>
                                                                            <i className="fas fa-trash"></i><span className='d-none d-sm-inline'> Delete</span>
                                                                        </button>
                                                                    }
                                                                </td>
                                                            </tr>)}
                                                            {dropUploads.filter(u => !u.isComplete).map((upload, index) =>
                                                                <tr key={'drop-' + index}>
                                                                    <td className="pl-0" colSpan={3}>
                                                                        <span className="text-truncate d-block mb-1">{upload.file.name}</span>
                                                                        {upload.isError
                                                                            ? <small className="text-danger"><i className="fas fa-times"></i> Upload failed</small>
                                                                            : <div className="progress" style={{ height: '4px' }}>
                                                                                <div className="progress-bar" style={{ width: upload.progress + '%' }} />
                                                                              </div>
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <div className="w-100 position-relative mt-sm-5">
                                        <hr className="text-300 mb-2" />
                                    </div>
                                    <div className="form-group mb-0">
                                        <div className="row no-gutters d-flex">
                                            <div className="col-12 d-flex justify-content-between">
                                                {currentView === WardenSiteViewStep.Review &&
                                                    <button className="btn btn-default btn-sm" onClick={() => setCurrentView(WardenSiteViewStep.CreateTicket)}><i className="fas fa-arrow-left"></i> Back</button>
                                                }
                                                {currentView === WardenSiteViewStep.CreateTicket &&
                                                    <button className="btn btn-default btn-sm" onClick={reset}><i className="fas fa-arrow-left"></i> Back</button>
                                                }
                                                <div className='d-flex justify-content-end'>
                                                    {currentView === WardenSiteViewStep.Review &&
                                                        <button type="button" className="btn btn-success btn-sm ml-2" onClick={() => createTicket()}><i className="fas fa-check"></i> Submit</button>
                                                    }
                                                    {currentView === WardenSiteViewStep.CreateTicket &&
                                                        <button type="button" className="btn btn-primary btn-sm ml-2" disabled={!canSave} onClick={() => setCurrentView(WardenSiteViewStep.Review)}> <i className="fas fa-eye"></i> Review</button>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }

                            {currentView === WardenSiteViewStep.AllowedVrm &&

                                <>
                                    <div className='container-fluid'>
                                        <h4 className="mb-sm-5 my-3 text-center">Vehicle is on the Allow List</h4>

                                        <div className="row mb-2">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">VRM</label>
                                            <div className="col-sm-8"><p className="small-number-plate mb-0">{allowedVrm.vrm}</p></div>
                                        </div>
                                        <div className="row mb-2">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">Vehicle Make</label>
                                            <div className="col-sm-8">
                                                <p class="form-control-plaintext form-control-sm outline-none" >{allowedVrm.vehicleMake}</p>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">Vehicle Model</label>
                                            <div className="col-sm-8">
                                                <p class="form-control-plaintext form-control-sm outline-none" >{allowedVrm.vehicleModel}</p>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">Colour</label>
                                            <div className="col-sm-8">
                                                <p class="form-control-plaintext form-control-sm outline-none" >{allowedVrm.colour}</p>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">Site</label>
                                            <div className="col-sm-8">
                                                <p class="form-control-plaintext form-control-sm outline-none" >{allowedVrm.siteName && allowedVrm.siteName !== null && <>{allowedVrm.siteName}</>}{!allowedVrm.siteName && <>All</>}</p>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">Bay</label>
                                            <div className="col-sm-8">
                                                <p class="form-control-plaintext form-control-sm outline-none" >{allowedVrm.roi && allowedVrm.roi}</p>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">Period</label>
                                            <div className="col-sm-8">

                                                {(allowedVrm.startDate === null || allowedVrm.endDate === null) &&
                                                    <p class="form-control-plaintext form-control-sm outline-none" >
                                                        Indefinite
                                                    </p>
                                                }
                                                {allowedVrm.startDate !== null && allowedVrm.endDate !== null &&
                                                    <p class="form-control-plaintext form-control-sm outline-none" >
                                                        {toDateString(allowedVrm.startDate)}, {toTimeString(allowedVrm.startDate)} to {toDateString(allowedVrm.endDate)}, {toTimeString(allowedVrm.endDate)}
                                                    </p>
                                                }
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label class="col-sm-4 col-form-label col-form-label-sm">Notes</label>
                                            <div className="col-sm-8">
                                                <p class="form-control-plaintext form-control-sm outline-none" >{allowedVrm.notes}</p>
                                            </div>
                                        </div>
                                    <div className="modal fade save-dialog success-dialog" id="confirm-override" tabIndex="-1" role="dialog">
                                        <div className="modal-dialog" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h4 className="modal-title">Create A Ticket</h4>
                                                </div>
                                                <div className="modal-body">
                                                    <p>Are you sure you want to override this allow list entry and create a ticket?</p>
                                                    {!stringHelpers.isNullOrEmpty(allowedVrm.roi) && <p>The allow list entry is for Bay: <b>{allowedVrm.roi}</b></p>}
                                                </div>
                                                <div className="modal-footer">
                                                    <div className='d-flex gap-2'>
                                                        <button type="button" className="btn btn-sm btn-secondary mr-2" data-dismiss="modal">Cancel</button>
                                                        <button type="button" className="btn btn-sm btn-danger" data-dismiss="modal" onClick={ () => setCurrentView(WardenSiteViewStep.CreateTicket) }>Confirm</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>

                                    <div className="w-100 position-relative mt-sm-5">
                                        <hr className="text-300 mb-2" />
                                    </div>
                                    <div className="form-group mb-0">
                                        <div className="row no-gutters d-flex">
                                            <div className="col-12 d-flex justify-content-between">
                                                <button className="btn btn-default btn-sm" onClick={reset}> <i className="fas fa-arrow-left"></i> Back</button>
                                                <button data-toggle="modal" data-target="#confirm-override" className="btn btn-danger btn-sm">Create A Ticket</button>
                                                {/* <button type="button" className="btn btn-success btn-sm ml-2" onClick={reset}>Next <i className="fas fa-arrow-right"></i></button> */}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                       
                        </div>
                    </div>
                </div>
            </div>
            { carouselOpen && carouselImages.length > 0 && (
                <Modal show onHide={ () => setCarouselOpen(false) } centered size="lg">
                    <Modal.Header className="bg-white d-flex justify-content-between p-2">
                        <p className="m-0 text-truncate mr-2" style={{ flex: 1, minWidth: 0 }} title={ carouselImages[carouselIndex]?.filename }>{ carouselImages[carouselIndex]?.filename }</p>
                    </Modal.Header>
                    <Modal.Body className="p-0">
                        <div className="carousel slide">
                            <div className="carousel-inner">
                                { carouselImages.map((image, i) => (
                                    <div key={ image.id } className={ `carousel-item${ i === carouselIndex ? ' active' : '' }` }>
                                        <img src={ image.url } alt={ image.filename } className="d-block w-100 attachment-carousel-img" />
                                    </div>
                                )) }
                            </div>
                            { carouselImages.length > 1 && (
                                <>
                                    <button className="carousel-control-prev gallery-chevron" onClick={ () => setCarouselIndex(i => (i - 1 + carouselImages.length) % carouselImages.length) }>
                                        <i className="fas fa-chevron-left" aria-hidden="true" />
                                    </button>
                                    <button className="carousel-control-next gallery-chevron" onClick={ () => setCarouselIndex(i => (i + 1) % carouselImages.length) }>
                                        <i className="fas fa-chevron-right" aria-hidden="true" />
                                    </button>
                                </>
                            ) }
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="py-1 px-3 d-flex align-items-center">
                        { carouselImages.length > 1 && <span className="small">{ carouselIndex + 1 } / { carouselImages.length }</span> }
                        <button className="btn btn-secondary btn-sm" onClick={ () => setCarouselOpen(false) }>Close</button>
                    </Modal.Footer>
                </Modal>
            ) }
            {!stringHelpers.isNullOrEmpty(errorMessage) && <ErrorModal message={errorMessage} onHide={() => setErrorMessage(null)} />}
            {!stringHelpers.isNullOrEmpty(successMessage) && <SuccessModal message={successMessage} onHide={() => setSuccessMessage(null)} />}
        </div>
    )
}
export default WardenSite;